import styleConstants from './constants';
import styleUtils from './utils';
const iterateAndCorrectStyles = (style) => {
    const obj = style;
    Object.keys(obj).forEach((item) => {
        if (typeof obj[item] === 'object') {
            iterateAndCorrectStyles(obj[item]);
        }
        else if (item === 'web' && !(typeof obj.desktop === 'undefined' || obj.desktop === null)) {
            obj[item] = obj.desktop;
        }
    });
    return Object.assign({}, obj);
};
const updateStyleForDesktop = (obj, isDesktop) => {
    if (!isDesktop) {
        return obj;
    }
    return iterateAndCorrectStyles(obj);
};
const styleService = {
    transformStyles: (widgetType, styles, isDesktop = false, transformStyleWidgetTypes = []) => {
        const styleCss = {};
        if ((widgetType && widgetType.indexOf('V2') > -1)
            || (transformStyleWidgetTypes.indexOf(widgetType) > -1)) {
            const stylesToTransform = styles || [];
            for (let i = 0; stylesToTransform.length > i; i += 1) {
                if (stylesToTransform[i]) {
                    const styleName = stylesToTransform[i].name;
                    if (styleName && stylesToTransform[i].style) {
                        const key = styleConstants.styleKeyMapping[styleName];
                        if (key) {
                            // check object and object key present or not with recursive function
                            styleCss[key] = updateStyleForDesktop(stylesToTransform[i].style, isDesktop);
                        }
                    }
                }
            }
        }
        return styleCss;
    },
    constants: styleConstants,
    utils: styleUtils,
};
export default styleService;
